import {VetineoFile} from "./file/vetineo-file.model";
import {VImage} from "./vet-clinic.model";

/**
 * Główny model reprezentujący wiadomość w systemie.
 */
export class VMessage {

  /** Wewnętrzny identyfikator numeryczny. */
  public id: number;

  /** Globalnie unikalny identyfikator wiadomości. */
  public uuid: string;

  /** Data i czas utworzenia wiadomości. */
  public created: Date;

  /** Typ wiadomości (kategoryzacja).
   */
  public type: string;

  /** Powiązana wizyta.
   */
  public vetReservationUUID: string;

  /** Nazwa nadawcy wyświetlana odbiorcy. */
  public fromName: string;

  /** Adres e-mail, z którego fizycznie wysłano wiadomość. */
  public fromEmail: string;

  /** Identyfikator użytkownika.
   */
  public userUUID: string;

  /** Lista identyfikatorów wielu odbiorców.
   */
  public multipleReceivers: string[];

  /** Lista identyfikatorów tagów.
   * Pozwala na dynamiczne targetowanie
   */
  public tagsUUIDs: string[];

  /** Lista identyfikatorów klinik.
   */
  public clinics: string[];

  /** Znacznik odczytu (Read Receipt).
   * Data i czas pierwszego wyświetlenia / otwarcia wiadomości przez odbiorcę.
   */
  public seen: Date;

  /** Temat wiadomości. */
  public subject: string;

  /** Treść wiadomości. */
  public content: string;

  /** Treść wiadomości w formacie HTML.
   */
  public contentHtml: string;

  /** Główny obrazek wyróżniający (Hero Image) dołączony do wiadomości.
   */
  public msgImageUUID: string;
  public msgImage: VImage;

  /** Tablica załączników. */
  public attachments: VetineoFile[];

}
